import React from "react";
import styled from "styled-components";

import { ReactComponent as CloseIcon } from "../assets/svg/closeIcon.svg";

type DataType = {
  title: string;
  text: JSX.Element;
};

export const EducationActivities: React.FC<{}> = () => {
  const [option, setOption] = React.useState<number>(-1);

  const handleSetOption = (id: number): void => {
    return option === id ? setOption(-1) : setOption(id);
  };

  const data: DataType[] = [
    {
      title: "Policy",
      text: (
        <p className="">
          Documents an organisation’s commitment to the health and wellbeing of
          staff. This sets clear expectations and ensures the sustainability of
          changes made even with staffing changes.
        </p>
      ),
    },
    {
      title: "Environment",
      text: (
        <p className="">
          Making healthy options and opportunities available to staff (e.g.
          providing healthy food options at meetings can influence a healthier
          choice).
        </p>
      ),
    },
    {
      title: "Education & Activities",
      text: (
        <>
          <p className="">
            Providing information on the risks associated with unhealthy
            behaviours and identifying healthier choices.
          </p>
          <p className="">
            Providing opportunities for those looking to make a change (e.g. a
            healthy cooking class or lunch time walking group).
          </p>
        </>
      ),
    },
  ];

  return (
    <>
      <strong className="d-block text-center text-primary mb-4">
        Click on the symbols below to reveal more information.
      </strong>
      <Pyramid>
        {data.map(({ title, text }, idx) => (
          <Layer
            key={idx}
            active={idx === option}
            onClick={() => handleSetOption(idx)}
          >
            {title}
          </Layer>
        ))}
        <Content onClick={() => handleSetOption(-1)} active={option !== -1}>
          <h2 className="h1 text-uppercase mb-4">
            {option === -1 ? "" : data[option].title}
          </h2>
          {option === -1 ? "" : data[option].text}
          <CloseIcon width={26} height={26} fill="white" />
        </Content>
      </Pyramid>
    </>
  );
};

const angle = "16.7%";
const base = "30rem";

const Pyramid = styled.div`
  position: relative;
  margin: 0 auto 1.5rem;
  width: ${base};
  height: ${base};
`;

const Layer = styled.button<{ active: boolean }>`
  width: 100%;
  height: 33%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-size: 1.5rem;
  font-weight: bold;
  color: ${(p) => p.theme.white};
  background: ${(p) => p.theme.info}aa;
  padding-bottom: 1.25rem;
  cursor: pointer;

  &:nth-child(1) {
    clip-path: polygon(
      50% 0,
      calc(50% + ${angle}) 100%,
      calc(50% - ${angle}) 100%
    );
  }
  &:nth-child(2) {
    background-color: ${(p) => p.theme.primary};
    clip-path: polygon(
      calc(50% - ${angle}) 0,
      calc(50% + ${angle}) 0,
      calc(50% + ${angle} * 2) 100%,
      calc(50% - ${angle} * 2) 100%
    );
  }
  &:nth-child(3) {
    clip-path: polygon(
      calc(50% - ${angle} * 2) 0,
      calc(50% + ${angle} * 2) 0,
      calc(50% + ${angle} * 3) 100%,
      calc(50% - ${angle} * 3) 100%
    );
  }
`;

const Content = styled.button<{ active: boolean }>`
  position: absolute;
  overflow: hidden;
  padding: ${(p) => (p.active ? "2rem" : 0)};
  top: ${(p) => (p.active ? 0 : "50%")};
  left: ${(p) => (p.active ? 0 : "50%")};
  width: ${(p) => (p.active ? "100%" : 0)};
  height: ${(p) => (p.active ? "100%" : 0)};
  opacity: ${(p) => (p.active ? 1 : 0)};
  z-index: ${(p) => (p.active ? 0 : 2)};
  color: ${(p) => p.theme.white};
  background-color: ${(p) => p.theme.primary};
  border: none;
  transition: 500ms all cubic-bezier(0.34, 1.56, 0.64, 1);
  & p {
    font-size: 1.25rem;
  }
`;
